// Generated by Avo VERSION 211.33.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "6QRBlQIlC0FcwIbMmz3g";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "8iTRcR3EaiFpvuy7uR4P",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "ZaA60qUig8uGf9ScQJhj",
          "se": (new Date()).toISOString(),
          "so": "gR6DdjXVWhOBV4NLWIgLh",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "8iTRcR3EaiFpvuy7uR4P",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "ZaA60qUig8uGf9ScQJhj",
          "se": (new Date()).toISOString(),
          "so": "gR6DdjXVWhOBV4NLWIgLh",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "ZaA60qUig8uGf9ScQJhj",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface Payload {
}

export const LogoutType = {
  'FORGOT_PINCODE': 'forgot_pincode',
  'FREMIUM_UPSELL': 'fremium_upsell',
  'INVALID_TOKEN': 'invalid_token',
  'MANUAL_LOGOUT': 'manual_logout',
  'NO_HOSTS_FOUND': 'no_hosts_found',
  'TEST_PLANNER_NOT_FOUND': 'test_planner_not_found',
  'NO_SECRETS_FOUND': 'no_secrets_found',
  'SAAS_USER_NOT_FOUND': 'saas_user_not_found',
  'ACCOUNT_USERS_IS_EMPTY': 'account_users_is_empty',
  'GET_ACCOUNT_USERS_FAILED': 'get_account_users_failed',
} as const;
export type LogoutTypeType = typeof LogoutType;
export type LogoutTypeValueType = LogoutTypeType[keyof LogoutTypeType];

export const PageCategory = {
  'CALENDAR': 'calendar',
  'CHAT': 'chat',
  'GENERAL_SETTINGS': 'general settings',
  'NOA_NOTES': 'noa notes',
  'OPINIONS': 'opinions',
  'PATIENTS': 'patients',
  'MARKETPLACE_DOCTOR_SETTINGS': 'marketplace doctor settings',
  'NOTIFICATIONS': 'notifications',
  'DISCOVERY_GUIDE': 'discovery guide',
  'PAYMENTS': 'payments',
  'ECOMMERCE': 'ecommerce',
} as const;
export type PageCategoryType = typeof PageCategory;
export type PageCategoryValueType = PageCategoryType[keyof PageCategoryType];

export const PageSource = {
  'ACCOUNT': 'account',
  'APP_FOOTER': 'app footer',
  'CALENDAR': 'calendar',
  'CALENDAR_SIDEBAR': 'calendar sidebar',
  'AI_VIRTUAL_PATIENT': 'ai virtual patient',
  'DEMO_SCRIPT': 'demo script',
  'NEW_SESSION': 'new session',
  'TAB_NAVIGATION': 'tab navigation',
  'CHAT_MENU': 'chat menu',
  'PAIENT_REQUESTS_LIST': 'paient requests list',
  'VISITS': 'visits',
  'AGENDA_BANNER': 'agenda banner',
  'DURING_VIDEO_CONSULTATIONS': 'during video consultations',
  'MEDICAL_EPISODE': 'medical episode',
  'VIDEO_CONSULTATIONS_FINISHED': 'video consultations finished',
} as const;
export type PageSourceType = typeof PageSource;
export type PageSourceValueType = PageSourceType[keyof PageSourceType];

export const UserType = {
  'DPWORKER': 'DPworker',
  'CLINIC_ADMIN': 'clinicAdmin',
  'DOCTOR': 'doctor',
  'PATIENT': 'patient',
  'SECRETARY': 'secretary',
  'SECRETARY_IN_MEDICAL_CENTER': 'secretaryInMedicalCenter',
  'NURSE': 'nurse',
  'SECRETARYMEDICALCENTER': 'secretarymedicalcenter',
} as const;
export type UserTypeType = typeof UserType;
export type UserTypeValueType = UserTypeType[keyof UserTypeType];

export const EventSource = {
  'BACKEND': 'backend',
  'DESKTOP_APP': 'desktop app',
  'MOBILE_APP': 'mobile app',
  'WEB': 'web',
  'WEBVIEW': 'webview',
} as const;
export type EventSourceType = typeof EventSource;
export type EventSourceValueType = EventSourceType[keyof EventSourceType];

export const PageSection = {
  'BLOCK': 'block',
  'BOOKING': 'booking',
  'CALENDAR_VIEW': 'calendar view',
  'CAMPAIGNS': 'campaigns',
  'INTERNAL_CHATS': 'internal chats',
  'MAIN': 'main',
  'MEDICAL_EPISODE_TEMPLATES': 'medical episode templates',
  'MEDICAL_FILES': 'medical files',
  'MEDICAL_PRINT_LAYOUTS': 'medical print layouts',
  'PATIENT_LIST': 'patient list',
  'PATIENT_MESSAGES': 'patient messages',
  'PATIENT_OPINIONS': 'patient opinions',
  'PATIENT_PROFILE': 'patient profile',
  'RECORDER': 'recorder',
  'REMINDER': 'reminder',
  'SIDEBAR': 'sidebar',
  'ACCOUNT_SETTINGS': 'account settings',
  'NOA_NOTES_WIDGET': 'noa notes widget',
  'ONBOARDING': 'onboarding',
  'RECORDING_SESSIONS': 'recording sessions',
  'SETTINGS': 'settings',
  'SUMMARY': 'summary',
  'TEMPLATES': 'templates',
  'CALENDAR_SIDEBAR': 'calendar sidebar',
  'EVENT_NOTIFICATIONS': 'event notifications',
  'INSIGHTS': 'insights',
  'AI_VIRTUAL_PATIENT': 'ai virtual patient',
  'DEMO_SCRIPT': 'demo script',
  'FREEMIUM_DASHBOARD': 'freemium dashboard',
  'INSURANCES': 'insurances',
  'PROFILES': 'profiles',
  'ADDRESSES': 'addresses',
  'CERTIFICATES': 'certificates',
  'FIRST_CLASS': 'first class',
  'MY_PROFILE_PROMOTION': 'my profile promotion',
  'ONLINE_BOOKING_CHANNELS': 'online booking channels',
  'PROFILE_EDITOR': 'profile editor',
  'QUESTIONS_AND_ANSWERS': 'questions and answers',
  'STAMPS': 'stamps',
  'PAYMENTS_SETTINGS': 'payments settings',
  'PATIENT_REQUESTS': 'patient requests',
  'MIGRATE': 'migrate',
  'MY_CURRENT_PLAN': 'my current plan',
  'NOA': 'noa',
  'UPGRADE': 'upgrade',
  'UPSELL': 'upsell',
  'SERVICE_SETTINGS': 'service settings',
} as const;
export type PageSectionType = typeof PageSection;
export type PageSectionValueType = PageSectionType[keyof PageSectionType];

export const PageType = {
  'CAMPAIGN_BUILDER': 'campaign builder',
  'CAMPAIGN_LIST': 'campaign list',
  'COGNIFIT': 'cognifit',
  'CUSTOM_SECTIONS': 'custom sections',
  'DOCUMENT_TEMPLATES': 'document templates',
  'FILE_SETTINGS': 'file settings',
  'FILE_TEMPLATES': 'file templates',
  'FILES_IMPORTED': 'files imported',
  'INBOX': 'inbox',
  'LAYOUT_EDITOR': 'layout editor',
  'MEDICAL_EPISODES': 'medical episodes',
  'MEDICAL_FILES': 'medical files',
  'PATIENT_DATA': 'patient data',
  'PATIENT_HIGHLIGHTS': 'patient highlights',
  'PAYMENTS': 'payments',
  'RESOLVED': 'resolved',
  'VISITS': 'visits',
  'AGENDA_LIST': 'agenda list',
  'DAILY_REPORT': 'daily report',
  'INFORMATION': 'information',
  'NOTIFICATION_SETTINGS': 'notification settings',
  'ONLINE_BOOKING': 'online booking',
  'ONLINE_CONSULTATION_CHANNELS': 'online consultation channels',
  'PAYMENT_SETTINGS': 'payment settings',
  'SERVICE_SETTINGS': 'service settings',
  'WORK_TIME_PERIODS': 'work time periods',
  'ALL_OPINIONS': 'all opinions',
  'AGENDA': 'agenda',
  'DAILY': 'daily',
  'DAILY_EVENTS': 'daily events',
  'FREE_SLOTS': 'free slots',
  'HIGHLIGHTED_OPINIONS': 'highlighted opinions',
  'PENDING_OPINIONS': 'pending opinions',
  'REPLIED_OPINIONS': 'replied opinions',
  'REPORTED_OPINIONS': 'reported opinions',
  'THREE_DAY': 'three day',
  'WEEKLY': 'weekly',
  'WEEKLY_EVENTS': 'weekly events',
  'INSURER_LIST': 'insurer list',
  'CALENDAR_REQUESTS': 'calendar requests',
  'PROFILE_EDITOR': 'profile editor',
  'PROFILES_LIST': 'profiles list',
  'ACTIVATION': 'activation',
  'MARKETING_TEXT_CONTENT': 'marketing text content',
  'MARKETING_VISUAL_CONTENT': 'marketing visual content',
  'PENDING_QUESTIONS': 'pending questions',
  'REPLIED_QUESTIONS': 'replied questions',
  'SETTINGS': 'settings',
  'WEBSITE': 'website',
  'WIDGET_GENERATION': 'widget generation',
  'AGENDA_SETTINGS': 'agenda settings',
  'EPISODE_TEMPLATES': 'episode templates',
  'ALL_REQUESTS': 'all requests',
  'PENDING_REQUESTS': 'pending requests',
  'RESOLVED_REQUESTS': 'resolved requests',
  'MAIN': 'main',
  'COMPANY': 'company',
  'DOCTOR': 'doctor',
  'FACILITY': 'facility',
  'MY_CURRENT_PLAN': 'my current plan',
  'PAYMENT': 'payment',
  'PRICING_PAGE': 'pricing page',
  'SUMMARY': 'summary',
  'THANKYOU': 'thankyou',
  'AVG_BOOKINGS_REPORT': 'avg bookings report',
  'TRAFFIC_SOURCES_REPORT': 'traffic sources report',
  'REGISTRATION_FLOW_PLAN_SELECTION': 'registration flow plan selection',
  'OPINION_DETAIL': 'opinion detail',
  'BOOKING_DETAIL': 'booking detail',
} as const;
export type PageTypeType = typeof PageType;
export type PageTypeValueType = PageTypeType[keyof PageTypeType];

export const LoginType = {
  'LOGIN': 'login',
  'MFA': 'mfa',
  'QR': 'qr',
  'REFRESH_TOKEN': 'refresh_token',
} as const;
export type LoginTypeType = typeof LoginType;
export type LoginTypeValueType = LoginTypeType[keyof LoginTypeType];

export const NoaNotesAppUsed = {
  '3RD_PARTY_PMS': '3rd party pms',
  'CLINIC_CLOUD': 'clinic cloud',
  'CONNECT': 'connect',
  'FEEGOW': 'feegow',
  'GIPO': 'gipo',
  'MYDR': 'mydr',
  'STANDALONE': 'standalone',
  'SAAS': 'saas',
} as const;
export type NoaNotesAppUsedType = typeof NoaNotesAppUsed;
export type NoaNotesAppUsedValueType = NoaNotesAppUsedType[keyof NoaNotesAppUsedType];

export const ProfileAttractionRate = {
  'ADVANCED': 'advanced',
  'ALL_STAR': 'all-star',
  'BASIC': 'basic',
  'EXPERT': 'expert',
} as const;
export type ProfileAttractionRateType = typeof ProfileAttractionRate;
export type ProfileAttractionRateValueType = ProfileAttractionRateType[keyof ProfileAttractionRateType];

export const DpSource = {
  'FEEGOW': 'feegow',
  'MKPL': 'mkpl',
  'MYDR': 'mydr',
  'NOA_APP': 'noa app',
  'SAAS': 'saas',
  'ONBOARDING_WIZARD': 'onboarding wizard',
  'NOA_NOTES_WIDGET': 'noa notes widget',
  'DP_SPACES': 'dp spaces',
  'NOA_HUB': 'noa hub',
  'GIPO': 'gipo',
  'NOA_PATIENT_SUMMARY': 'noa patient summary',
  '3RD_PARTY_PMS': '3rd party pms',
  'CLINIC_CLOUD': 'clinic cloud',
  'NOA_BOOKING': 'noa booking',
} as const;
export type DpSourceType = typeof DpSource;
export type DpSourceValueType = DpSourceType[keyof DpSourceType];

let sysEventSource: any;
let sysDpSource: any;
let sysScreenHeigth: any;
let sysScreenWidth: any;
let sysPmsSystem: any;

export function setSystemProperties(properties: {eventSource: EventSourceValueType;
    dpSource: DpSourceValueType;
    screenHeigth: number;
    screenWidth: number;
    pmsSystem?: string | null | undefined}) {
  if (properties.eventSource !== null && properties.eventSource !== undefined) {
    sysEventSource = properties.eventSource;
  }
  if (properties.dpSource !== null && properties.dpSource !== undefined) {
    sysDpSource = properties.dpSource;
  }
  if (properties.screenHeigth !== null && properties.screenHeigth !== undefined) {
    sysScreenHeigth = properties.screenHeigth;
  }
  if (properties.screenWidth !== null && properties.screenWidth !== undefined) {
    sysScreenWidth = properties.screenWidth;
  }
  if (properties.pmsSystem !== null && properties.pmsSystem !== undefined) {
    sysPmsSystem = properties.pmsSystem;
  }
}

let DocplannerMainCustomersAmplitude: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {eventSource: EventSourceValueType;
    dpSource: DpSourceValueType;
    screenHeigth: number;
    screenWidth: number;
    pmsSystem?: string | null | undefined},
    destinationOptions: any,
    DocplannerMainCustomersAmplitudeDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  setSystemProperties(systemProperties);
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    
    DocplannerMainCustomersAmplitude = DocplannerMainCustomersAmplitudeDestination;
    if (__AVO_ENV__ === 'prod') {
      DocplannerMainCustomersAmplitude && DocplannerMainCustomersAmplitude.make && DocplannerMainCustomersAmplitude.make(__AVO_ENV__, "6ad5d4c4d3bacb7d2bbf73f4fda309fe");
    } else if (__AVO_ENV__ === 'dev') {
      DocplannerMainCustomersAmplitude && DocplannerMainCustomersAmplitude.make && DocplannerMainCustomersAmplitude.make(__AVO_ENV__, "0861915aeacdb64e82cd5c7f663c1ae2");
    } else {
      console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Docplanner Main - customers (amplitude). Head to destination settings in Avo to set a staging key.");
      DocplannerMainCustomersAmplitude && DocplannerMainCustomersAmplitude.make && DocplannerMainCustomersAmplitude.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface PageViewedProperties {
  pageCategory?: PageCategoryValueType | null | undefined;
  pageSection?: PageSectionValueType | null | undefined;
  pageType?: PageTypeValueType | null | undefined;
  pageUrl: string;
  pagePath: string;
  pageHostname: string;
  pageTypeFree: string;
}
/**
 * page_viewed: Triggered when the page loads
 * 
 * @param properties the properties associated with this event
 * @param properties.pageCategory: First level of hierarchy. Used to classify website and app content into broad sections. This primary classification helps in organizing and segmenting user interactions and behavior across different types of content.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageSection: Second layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageType: Type of page being displayed (Onboarding wizard)
 * Third layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category' and 'section'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageUrl: Complete URL from the page where the action is being triggered (including querystring). Frequently used window.location.href by developers
 * @param properties.pagePath: Page path without querystring (text after ? icon in the URL), to avoid disaggregation. 
 * Whenever the path includes an ID (like patientId or episodeId), a timestamp, or a randomly generated value, we should use a placeholder instead of the actual ID. 
 * For example, instead of “/booking/seleccionar-fecha/193278/285111/2025-06-13T09:00:00+02:00/2122252” we should send “/booking/seleccionar-fecha/[doctor_id]/[address_id]/[timestamp]/[user_id]”
 * @param properties.pageHostname: Hostname of the page loaded
 * @param properties.pageTypeFree: Same as page_type property but without restricted values
 * We'll find it in Amplitude as 'page_type' instead of 'page_type_free' merged with 'page_type' property with restricted values.
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/QxWNv7veYyO8OuW59Xr65}
 */
export function pageViewed(properties: PageViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.pageCategory !== undefined && properties.pageCategory !== null ?
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: properties.pageCategory}) :
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: null});
  properties.pageSection !== undefined && properties.pageSection !== null ?
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: properties.pageSection}) :
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: null});
  properties.pageType !== undefined && properties.pageType !== null ?
    eventPropertiesArray.push({id: "UMH-8vf-gOxjFNieQ86Ew", name: "page_type", value: properties.pageType}) :
    eventPropertiesArray.push({id: "UMH-8vf-gOxjFNieQ86Ew", name: "page_type", value: null});
  eventPropertiesArray.push({id: "CdQwMgzXad5mxij9Fp763", name: "page_url", value: properties.pageUrl});
  eventPropertiesArray.push({id: "7DscT6chtQ6ijH9UbTS_f", name: "page_path", value: properties.pagePath});
  eventPropertiesArray.push({id: "hajXHQ5dXmnA09GKx8o9u", name: "page_hostname", value: properties.pageHostname});
  eventPropertiesArray.push({id: "ZQxcdxRRhIrJAfg5GCUoJ", name: "page_type_free", value: properties.pageTypeFree});
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "QxWNv7veYyO8OuW59Xr65", "a75d71d9fb176211c42b28047fb6214369113a9390b4fed0e03cd23ba26271b3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("page_viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("QxWNv7veYyO8OuW59Xr65", "page_viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("page_viewed", eventProperties, "QxWNv7veYyO8OuW59Xr65", "a75d71d9fb176211c42b28047fb6214369113a9390b4fed0e03cd23ba26271b3");
    }
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.logEvent("page_viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PageViewedFreemiumProperties {
  pageCategory?: PageCategoryValueType | null | undefined;
  pageSection?: PageSectionValueType | null | undefined;
  pageType?: PageTypeValueType | null | undefined;
  pageUrl: string;
  pagePath: string;
  pageHostname: string;
  pageTypeFree: string;
  numCalendarRequestTotal?: number | null | undefined;
  numCalendarRequestContacts?: number | null | undefined;
  profileAttractionRate?: ProfileAttractionRateValueType | null | undefined;
}
/**
 * page_viewed: Triggered when the page loads, variant description: pages on freemium dashboard has extra info included in this variant
 * 
 * @param properties the properties associated with this event
 * @param properties.pageCategory: First level of hierarchy. Used to classify website and app content into broad sections. This primary classification helps in organizing and segmenting user interactions and behavior across different types of content.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageSection: Second layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageType: Type of page being displayed (Onboarding wizard)
 * Third layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category' and 'section'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageUrl: Complete URL from the page where the action is being triggered (including querystring). Frequently used window.location.href by developers
 * @param properties.pagePath: Page path without querystring (text after ? icon in the URL), to avoid disaggregation. 
 * Whenever the path includes an ID (like patientId or episodeId), a timestamp, or a randomly generated value, we should use a placeholder instead of the actual ID. 
 * For example, instead of “/booking/seleccionar-fecha/193278/285111/2025-06-13T09:00:00+02:00/2122252” we should send “/booking/seleccionar-fecha/[doctor_id]/[address_id]/[timestamp]/[user_id]”
 * @param properties.pageHostname: Hostname of the page loaded
 * @param properties.pageTypeFree: Same as page_type property but without restricted values
 * We'll find it in Amplitude as 'page_type' instead of 'page_type_free' merged with 'page_type' property with restricted values.
 * @param properties.numCalendarRequestTotal: Total number of calendar request shown in the page
 * @param properties.numCalendarRequestContacts: Number of non anonymized contact details on calendar request page
 * @param properties.profileAttractionRate: Captures the attraction ranking of a doctor's profile for patients based on the information filled in for their public profile.
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/QxWNv7veYyO8OuW59Xr65.hqgdBFSU5IE1QjS6MYNFL}
 */
export function pageViewedFreemium(properties: PageViewedFreemiumProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.pageCategory !== undefined && properties.pageCategory !== null ?
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: properties.pageCategory}) :
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: null});
  properties.pageSection !== undefined && properties.pageSection !== null ?
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: properties.pageSection}) :
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: null});
  properties.pageType !== undefined && properties.pageType !== null ?
    eventPropertiesArray.push({id: "UMH-8vf-gOxjFNieQ86Ew", name: "page_type", value: properties.pageType}) :
    eventPropertiesArray.push({id: "UMH-8vf-gOxjFNieQ86Ew", name: "page_type", value: null});
  eventPropertiesArray.push({id: "CdQwMgzXad5mxij9Fp763", name: "page_url", value: properties.pageUrl});
  eventPropertiesArray.push({id: "7DscT6chtQ6ijH9UbTS_f", name: "page_path", value: properties.pagePath});
  eventPropertiesArray.push({id: "hajXHQ5dXmnA09GKx8o9u", name: "page_hostname", value: properties.pageHostname});
  eventPropertiesArray.push({id: "ZQxcdxRRhIrJAfg5GCUoJ", name: "page_type_free", value: properties.pageTypeFree});
  properties.numCalendarRequestTotal !== undefined && properties.numCalendarRequestTotal !== null ?
    eventPropertiesArray.push({id: "LHK0HRFDMRVQ-JNMZB_Bn", name: "num_calendar_request_total", value: properties.numCalendarRequestTotal}) :
    eventPropertiesArray.push({id: "LHK0HRFDMRVQ-JNMZB_Bn", name: "num_calendar_request_total", value: null});
  properties.numCalendarRequestContacts !== undefined && properties.numCalendarRequestContacts !== null ?
    eventPropertiesArray.push({id: "X-IZz3rFLJJc212yxka9b", name: "num_calendar_request_contacts", value: properties.numCalendarRequestContacts}) :
    eventPropertiesArray.push({id: "X-IZz3rFLJJc212yxka9b", name: "num_calendar_request_contacts", value: null});
  properties.profileAttractionRate !== undefined && properties.profileAttractionRate !== null ?
    eventPropertiesArray.push({id: "f4YImOV1Nt1MjVJVx76Fz", name: "profile_attraction_rate", value: properties.profileAttractionRate}) :
    eventPropertiesArray.push({id: "f4YImOV1Nt1MjVJVx76Fz", name: "profile_attraction_rate", value: null});
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "QxWNv7veYyO8OuW59Xr65.hqgdBFSU5IE1QjS6MYNFL", "0c4df61a999b8d85c1b8697ff09eb4716720db56b18a8cb55de99e5338e02826", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("page_viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("QxWNv7veYyO8OuW59Xr65.hqgdBFSU5IE1QjS6MYNFL", "page_viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("page_viewed", eventProperties, "QxWNv7veYyO8OuW59Xr65.hqgdBFSU5IE1QjS6MYNFL", "0c4df61a999b8d85c1b8697ff09eb4716720db56b18a8cb55de99e5338e02826");
    }
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.logEvent("page_viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PageViewedPaymentsProperties {
  pageCategory?: PageCategoryValueType | null | undefined;
  pageSection?: PageSectionValueType | null | undefined;
  pageType?: PageTypeValueType | null | undefined;
  pageUrl: string;
  pagePath: string;
  pageHostname: string;
  pageTypeFree: string;
  agendaId?: string | null | undefined;
}
/**
 * page_viewed: Triggered when the page loads, variant description: pages on payments has extra info included in this variant
 * 
 * @param properties the properties associated with this event
 * @param properties.pageCategory: First level of hierarchy. Used to classify website and app content into broad sections. This primary classification helps in organizing and segmenting user interactions and behavior across different types of content.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageSection: Second layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageType: Type of page being displayed (Onboarding wizard)
 * Third layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category' and 'section'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageUrl: Complete URL from the page where the action is being triggered (including querystring). Frequently used window.location.href by developers
 * @param properties.pagePath: Page path without querystring (text after ? icon in the URL), to avoid disaggregation. 
 * Whenever the path includes an ID (like patientId or episodeId), a timestamp, or a randomly generated value, we should use a placeholder instead of the actual ID. 
 * For example, instead of “/booking/seleccionar-fecha/193278/285111/2025-06-13T09:00:00+02:00/2122252” we should send “/booking/seleccionar-fecha/[doctor_id]/[address_id]/[timestamp]/[user_id]”
 * @param properties.pageHostname: Hostname of the page loaded
 * @param properties.pageTypeFree: Same as page_type property but without restricted values
 * We'll find it in Amplitude as 'page_type' instead of 'page_type_free' merged with 'page_type' property with restricted values.
 * @param properties.agendaId: ID of the agenda (aka schedule)
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/QxWNv7veYyO8OuW59Xr65.44lqgfUjqKV18ZfhvQuLK}
 */
export function pageViewedPayments(properties: PageViewedPaymentsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.pageCategory !== undefined && properties.pageCategory !== null ?
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: properties.pageCategory}) :
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: null});
  properties.pageSection !== undefined && properties.pageSection !== null ?
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: properties.pageSection}) :
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: null});
  properties.pageType !== undefined && properties.pageType !== null ?
    eventPropertiesArray.push({id: "UMH-8vf-gOxjFNieQ86Ew", name: "page_type", value: properties.pageType}) :
    eventPropertiesArray.push({id: "UMH-8vf-gOxjFNieQ86Ew", name: "page_type", value: null});
  eventPropertiesArray.push({id: "CdQwMgzXad5mxij9Fp763", name: "page_url", value: properties.pageUrl});
  eventPropertiesArray.push({id: "7DscT6chtQ6ijH9UbTS_f", name: "page_path", value: properties.pagePath});
  eventPropertiesArray.push({id: "hajXHQ5dXmnA09GKx8o9u", name: "page_hostname", value: properties.pageHostname});
  eventPropertiesArray.push({id: "ZQxcdxRRhIrJAfg5GCUoJ", name: "page_type_free", value: properties.pageTypeFree});
  properties.agendaId !== undefined && properties.agendaId !== null ?
    eventPropertiesArray.push({id: "WEdZSRbQwBEG1nkqWr6L7", name: "agenda_id", value: properties.agendaId}) :
    eventPropertiesArray.push({id: "WEdZSRbQwBEG1nkqWr6L7", name: "agenda_id", value: null});
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "QxWNv7veYyO8OuW59Xr65.44lqgfUjqKV18ZfhvQuLK", "fc5c3b2ad04dfa84e90d02ff9c090f6ed8dbb13448a244a98c19a52bb6ec388d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("page_viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("QxWNv7veYyO8OuW59Xr65.44lqgfUjqKV18ZfhvQuLK", "page_viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("page_viewed", eventProperties, "QxWNv7veYyO8OuW59Xr65.44lqgfUjqKV18ZfhvQuLK", "fc5c3b2ad04dfa84e90d02ff9c090f6ed8dbb13448a244a98c19a52bb6ec388d");
    }
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.logEvent("page_viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PageViewedWithMinuspageMinussourceProperties {
  pageCategory?: PageCategoryValueType | null | undefined;
  pageSection?: PageSectionValueType | null | undefined;
  pageType?: PageTypeValueType | null | undefined;
  pageUrl: string;
  pagePath: string;
  pageHostname: string;
  pageTypeFree: string;
  pageSource?: PageSourceValueType | null | undefined;
}
/**
 * page_viewed: Triggered when the page loadsvariant description: This variant applies for those pages that collect information about the entry point that brough the user to the page loading.
 * 
 * @param properties the properties associated with this event
 * @param properties.pageCategory: First level of hierarchy. Used to classify website and app content into broad sections. This primary classification helps in organizing and segmenting user interactions and behavior across different types of content.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageSection: Second layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageType: Type of page being displayed (Onboarding wizard)
 * Third layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category' and 'section'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageUrl: Complete URL from the page where the action is being triggered (including querystring). Frequently used window.location.href by developers
 * @param properties.pagePath: Page path without querystring (text after ? icon in the URL), to avoid disaggregation. 
 * Whenever the path includes an ID (like patientId or episodeId), a timestamp, or a randomly generated value, we should use a placeholder instead of the actual ID. 
 * For example, instead of “/booking/seleccionar-fecha/193278/285111/2025-06-13T09:00:00+02:00/2122252” we should send “/booking/seleccionar-fecha/[doctor_id]/[address_id]/[timestamp]/[user_id]”
 * @param properties.pageHostname: Hostname of the page loaded
 * @param properties.pageTypeFree: Same as page_type property but without restricted values
 * We'll find it in Amplitude as 'page_type' instead of 'page_type_free' merged with 'page_type' property with restricted values.
 * @param properties.pageSource: Indicates where the user came from. The page from which they clicked to land on the current page/screen.
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/QxWNv7veYyO8OuW59Xr65.8FcqeBGKQY-1VHtHIhRDQ}
 */
export function pageViewedWithPageSource(properties: PageViewedWithMinuspageMinussourceProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.pageCategory !== undefined && properties.pageCategory !== null ?
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: properties.pageCategory}) :
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: null});
  properties.pageSection !== undefined && properties.pageSection !== null ?
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: properties.pageSection}) :
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: null});
  properties.pageType !== undefined && properties.pageType !== null ?
    eventPropertiesArray.push({id: "UMH-8vf-gOxjFNieQ86Ew", name: "page_type", value: properties.pageType}) :
    eventPropertiesArray.push({id: "UMH-8vf-gOxjFNieQ86Ew", name: "page_type", value: null});
  eventPropertiesArray.push({id: "CdQwMgzXad5mxij9Fp763", name: "page_url", value: properties.pageUrl});
  eventPropertiesArray.push({id: "7DscT6chtQ6ijH9UbTS_f", name: "page_path", value: properties.pagePath});
  eventPropertiesArray.push({id: "hajXHQ5dXmnA09GKx8o9u", name: "page_hostname", value: properties.pageHostname});
  eventPropertiesArray.push({id: "ZQxcdxRRhIrJAfg5GCUoJ", name: "page_type_free", value: properties.pageTypeFree});
  properties.pageSource !== undefined && properties.pageSource !== null ?
    eventPropertiesArray.push({id: "Byw6Av05t9yS15rJsz2Bk", name: "page_source", value: properties.pageSource}) :
    eventPropertiesArray.push({id: "Byw6Av05t9yS15rJsz2Bk", name: "page_source", value: null});
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "QxWNv7veYyO8OuW59Xr65.8FcqeBGKQY-1VHtHIhRDQ", "33f83cac96fd25a8f10be672a9b9dc71568f9fb3095f8ef1a5d758d1dd9f7ae5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("page_viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("QxWNv7veYyO8OuW59Xr65.8FcqeBGKQY-1VHtHIhRDQ", "page_viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("page_viewed", eventProperties, "QxWNv7veYyO8OuW59Xr65.8FcqeBGKQY-1VHtHIhRDQ", "33f83cac96fd25a8f10be672a9b9dc71568f9fb3095f8ef1a5d758d1dd9f7ae5");
    }
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.logEvent("page_viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * user_unidentified: This is an event to pass "Unidentify User" action only. It's fired right after "user_logged_out" event, when user successfully logs out. 
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/tVNDoeANqNounbg-tzBzC}
 */
export function userUnidentified() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "tVNDoeANqNounbg-tzBzC", "9a1f5b1bbdce1c41b235a8cf99478d56abab38b391d02aef107867fee0e16071", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("user_unidentified", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("tVNDoeANqNounbg-tzBzC", "user_unidentified", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.unidentify();
  } else {
    // do nothing
  }
}

export interface UserLoggedOutProperties {
  logoutType: LogoutTypeValueType;
}
/**
 * user_logged_out: This is an event to pass "Log event" action only. It's fired before "GENERAL__user_unidentify" event, when user successfully logs out. 
 * 
 * @param properties the properties associated with this event
 * @param properties.logoutType: We log different types of user logout depending on how user was logout
 * - INVALID_TOKEN: This is a message return from back-end telling us that the refresh token we used is invalid.
 * - SAAS_USER_NOT_FOUND: SSO is able to login the user but the same user is not defined in the SAAS.
 * - FORGOT_PINCODE: User is logging out because they forgot their pincode which is store in the internal memory of the device
 * - NO_SECRETS_FOUND: User has security enabled and for some reasons we are not able to get the secrets from the device.
 * - TEST_PLANNER_NOT_FOUND: User is logging out because the testplanner selected is invalid or not found.
 * - NO_HOSTS_FOUND: User is logging out because they don't have a host.
 * - MANUAL_LOGOUT: User is logging out manually.
 * - FREMIUM_UPSELL: User is logging out because they are on the freemium plan.
 * - GET_ACCOUNT_USERS_FAILED: User is logging out because the SSO tokens are fine but there is an error trying to obtain the info from /accountusers
 * - ACCOUNT_USERS_IS_EMPTY:  User is logging out because the SSO tokens are fine but the list of users coming from /accountusers is empty. Usually when the user is not migrated to SaaS.
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/BNPJt7tVSje7e8ZulEfJr}
 */
export function userLoggedOut(properties: UserLoggedOutProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "9-ocvnGOjivcVA4LzLEUo", name: "logout_type", value: properties.logoutType});
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "BNPJt7tVSje7e8ZulEfJr", "580b6e3115cd2292563b974cdc5deeaa70d33e1218dacfb7ad45483000f1bc98", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("user_logged_out", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("BNPJt7tVSje7e8ZulEfJr", "user_logged_out", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("user_logged_out", eventProperties, "BNPJt7tVSje7e8ZulEfJr", "580b6e3115cd2292563b974cdc5deeaa70d33e1218dacfb7ad45483000f1bc98");
    }
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.logEvent("user_logged_out", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserLoggedInProperties {
  utmTerm?: string | null | undefined;
  utmSource?: string | null | undefined;
  utmMedium?: string | null | undefined;
  utmContent?: string | null | undefined;
  utmCampaign?: string | null | undefined;
  userId_: string;
  loginType: LoginTypeValueType;
  isFirstLogin: boolean;
}
/**
 * user_logged_in: User successfully logged in to our product
 * 
 * @param properties the properties associated with this event
 * @param properties.utmTerm: UTM term parameter used for dynamic_links
 * The paid search keywords
 * @param properties.utmSource: UTM source parameter used for dynamic_links
 * The referrer which brought the user to the app
 * @param properties.utmMedium: UTM medium parameter used for dynamic_links
 * The marketing medium such as email, cpc, or social
 * @param properties.utmContent: UTM content parameter used for dynamic_links
 * Used to differentiate similar content or links within the same ad
 * @param properties.utmCampaign: UTM campaign parameter used for dynamic_links.
 * The campaign name for product, promo code, or slogan
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.loginType: Describes how user logged-in in the mobile app.
 * @param properties.isFirstLogin: In case this is first time that user logged-in in the mobile app log true otherwise false
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/QQUE8I7z_Pp6gfc8pBOiy}
 */
export function userLoggedIn(properties: UserLoggedInProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "FMTIXzMmCQcdxpcEFskRB", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "FMTIXzMmCQcdxpcEFskRB", name: "utm_term", value: null});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "cncCZpDHYReujOdFbDOn2", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "cncCZpDHYReujOdFbDOn2", name: "utm_source", value: null});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "h5EZ01wh4CmXoVjAtt1A5", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "h5EZ01wh4CmXoVjAtt1A5", name: "utm_medium", value: null});
  properties.utmContent !== undefined && properties.utmContent !== null ?
    eventPropertiesArray.push({id: "_eHaKzmEwqSz--JWFxSTR", name: "utm_content", value: properties.utmContent}) :
    eventPropertiesArray.push({id: "_eHaKzmEwqSz--JWFxSTR", name: "utm_content", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "9jttpwPkOmI05fySyXG1c", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "9jttpwPkOmI05fySyXG1c", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "YVpAlJRxfZ00cAiQhGcU1", name: "login_type", value: properties.loginType});
  eventPropertiesArray.push({id: "mgbtqTEIcSiMPfV0BbGMc", name: "is_first_login", value: properties.isFirstLogin});
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "QQUE8I7z_Pp6gfc8pBOiy", "20978c119a2917d96a6e9a9525e4ab0db08206f55c88479a01b3a1bb95d83125", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("user_logged_in", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("QQUE8I7z_Pp6gfc8pBOiy", "user_logged_in", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("user_logged_in", eventProperties, "QQUE8I7z_Pp6gfc8pBOiy", "20978c119a2917d96a6e9a9525e4ab0db08206f55c88479a01b3a1bb95d83125");
    }
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.identify(properties.userId_);
    DocplannerMainCustomersAmplitude.logEvent("user_logged_in", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserPropertiesSetProperties {
  userId_: string;
  mkplDoctorId?: string | null | undefined;
  mkplFacilityId?: string | null | undefined;
  mkplUserId?: string | null | undefined;
  pmsUserId?: string | null | undefined;
  saasDoctorId?: string | null | undefined;
  saasFacilityId?: string | null | undefined;
  saasUserId?: string | null | undefined;
  sourceUserId?: string | null | undefined;
  userType?: UserTypeValueType | null | undefined;
  countryCode?: string | null | undefined;
  isUserIntegrated?: boolean | null | undefined;
  hubspotUserId?: string | null | undefined;
  isInternalUser?: boolean | null | undefined;
  mainSpecialization?: string | null | undefined;
  noaNotesAppUsed?: NoaNotesAppUsedValueType | null | undefined;
  profileAttractionRateUserProp?: string | null | undefined;
  pmsDoctorId?: string | null | undefined;
  hasActivatedNoaNotesTrial?: boolean | null | undefined;
  noaNotesTrialExpirationDate?: string | null | undefined;
}
/**
 * user_properties_set: This event is designed to pass or update user property data
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.mkplDoctorId: Value from stage_marketplace.doctor.id, if available
 * @param properties.mkplFacilityId: Value from stage_marketplace.facility.id, if available
 * @param properties.mkplUserId: One of following value if meets criteria:
 * 1) Value from stage_marketplace.user_doctor_worker.doctor_id, when user_type = doctor; 
 * 2) Value from stage_marketplace.user.id, when user_type = patient;
 * 3) Value from stage_marketplace.user_doctor_worker.id where doctor_id is null, when user_type = DPworker
 * @param properties.pmsUserId: PMS generated user ID
 * @param properties.saasDoctorId: Value from saas.users.id where user_type = 1, if available
 * @param properties.saasFacilityId: Value from saas.users.id where user_type = 3, if available
 * @param properties.saasUserId: One of following value if meets criteria:
 * 1) Value from saas.users.id where user_type = 1, when user_type = doctor;
 * 2) Value from saas.users.id where user_type = 4, when user_type = secretary;
 * 3) Value from saas.users.id where user_type = 6, when user_type = secretaryInMedicalCenter;
 * 4) Value from saas.users.id where user_type = 3, when user_type = clinicAdmin.
 * @param properties.sourceUserId: User ID coming from the native destination, so if we are on saas it will be saas_user_id, if Feegow, it will be user_id from Feegow ecosystem, etc.
 * @param properties.userType: Self explanatory
 * @param properties.countryCode: User's country. 2 lowercase letters country code user belongs to. , should match regex: ^[a-z]{2}$
 * It refers to the local market, not to the country from which the user accesses the product.
 * For example, if a user accesses doctoralia.es from France, the country_code will be 'es' and not 'fr.'
 * @param properties.isUserIntegrated: For PMS only. Returns true whenever user is integrated to DP
 * @param properties.hubspotUserId: User ID coming from HubSpot
 * @param properties.isInternalUser: Returns true when user is an internal user (uses docplanner.com email domain). For our internal PMSes uses email domain of the PMS. 
 * It also returns true when is a testing user, used by docplanner employees to test our product.
 * @param properties.mainSpecialization: The main specialization of a doctor.
 * @param properties.noaNotesAppUsed: This is similar to the noa_notes_client system event property. We need it as a user property for segmentation purposes in Amplitude Feature Flags.
 * @param properties.profileAttractionRateUserProp: Captures the attraction ranking of a doctor's profile for patients based on the information filled in for their public profile. 
 * This property is set only when the freemium dashboard page is loaded. If a new user lands on a different page upon creating their account, they won't receive this information until they visit the freemium dashboard.
 * @param properties.pmsDoctorId: PMS Doctor ID. 
 * bi.dbt_refresher.mart_pms_user.pms_doctor_id
 * @param properties.hasActivatedNoaNotesTrial: Indicates if the user has activated Noa Trial at some point. This property should be combined with noa_notes_trial_expiration_date, to know if the user stills on trial or if it's expired.
 * @param properties.noaNotesTrialExpirationDate: Expiration date of the Noa Notes Trial. We should follow the following format: yyyy-mm-dd
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/YHsSWlG3j0MsyDXAww_tz}
 */
export function userPropertiesSet(properties: UserPropertiesSetProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.mkplDoctorId !== undefined && properties.mkplDoctorId !== null ?
    userPropertiesArray.push({id: "ja9qDIylWzlEoZwbmrujy", name: "mkpl_doctor_id", value: properties.mkplDoctorId}) :
    userPropertiesArray.push({id: "ja9qDIylWzlEoZwbmrujy", name: "mkpl_doctor_id", value: null});
  properties.mkplFacilityId !== undefined && properties.mkplFacilityId !== null ?
    userPropertiesArray.push({id: "a-_AzEB5hLAR-0ffnK_SJ", name: "mkpl_facility_id", value: properties.mkplFacilityId}) :
    userPropertiesArray.push({id: "a-_AzEB5hLAR-0ffnK_SJ", name: "mkpl_facility_id", value: null});
  properties.mkplUserId !== undefined && properties.mkplUserId !== null ?
    userPropertiesArray.push({id: "StFAcqzfrMtXXpk7gP_lq", name: "mkpl_user_id", value: properties.mkplUserId}) :
    userPropertiesArray.push({id: "StFAcqzfrMtXXpk7gP_lq", name: "mkpl_user_id", value: null});
  properties.pmsUserId !== undefined && properties.pmsUserId !== null ?
    userPropertiesArray.push({id: "DMnAszKkTLJmpL2bKbS2n", name: "pms_user_id", value: properties.pmsUserId}) :
    userPropertiesArray.push({id: "DMnAszKkTLJmpL2bKbS2n", name: "pms_user_id", value: null});
  properties.saasDoctorId !== undefined && properties.saasDoctorId !== null ?
    userPropertiesArray.push({id: "qXM4zZ1lobTXhmkR33QHB", name: "saas_doctor_id", value: properties.saasDoctorId}) :
    userPropertiesArray.push({id: "qXM4zZ1lobTXhmkR33QHB", name: "saas_doctor_id", value: null});
  properties.saasFacilityId !== undefined && properties.saasFacilityId !== null ?
    userPropertiesArray.push({id: "5pL3ZetEtLLznCWef9kjO", name: "saas_facility_id", value: properties.saasFacilityId}) :
    userPropertiesArray.push({id: "5pL3ZetEtLLznCWef9kjO", name: "saas_facility_id", value: null});
  properties.saasUserId !== undefined && properties.saasUserId !== null ?
    userPropertiesArray.push({id: "0t74VLuL1w8-wqh0-c3_6", name: "saas_user_id", value: properties.saasUserId}) :
    userPropertiesArray.push({id: "0t74VLuL1w8-wqh0-c3_6", name: "saas_user_id", value: null});
  properties.sourceUserId !== undefined && properties.sourceUserId !== null ?
    userPropertiesArray.push({id: "u-SWkkrqvko09hXWpTaF-", name: "source_user_id", value: properties.sourceUserId}) :
    userPropertiesArray.push({id: "u-SWkkrqvko09hXWpTaF-", name: "source_user_id", value: null});
  properties.userType !== undefined && properties.userType !== null ?
    userPropertiesArray.push({id: "F4scsTw_aD__zLtt2ff-e", name: "user_type", value: properties.userType}) :
    userPropertiesArray.push({id: "F4scsTw_aD__zLtt2ff-e", name: "user_type", value: null});
  properties.countryCode !== undefined && properties.countryCode !== null ?
    userPropertiesArray.push({id: "yhSzBbnofK388pp58urqf", name: "country_code", value: properties.countryCode}) :
    userPropertiesArray.push({id: "yhSzBbnofK388pp58urqf", name: "country_code", value: null});
  properties.isUserIntegrated !== undefined && properties.isUserIntegrated !== null ?
    userPropertiesArray.push({id: "1qdS_D-dRMrVYCIlJ25sm", name: "is_user_integrated", value: properties.isUserIntegrated}) :
    userPropertiesArray.push({id: "1qdS_D-dRMrVYCIlJ25sm", name: "is_user_integrated", value: null});
  properties.hubspotUserId !== undefined && properties.hubspotUserId !== null ?
    userPropertiesArray.push({id: "5b4Hf14v3rTwN65RJ_2yy", name: "hubspot_user_id", value: properties.hubspotUserId}) :
    userPropertiesArray.push({id: "5b4Hf14v3rTwN65RJ_2yy", name: "hubspot_user_id", value: null});
  properties.isInternalUser !== undefined && properties.isInternalUser !== null ?
    userPropertiesArray.push({id: "A8SbkdXDgDaKwF_XPeIP8", name: "is_internal_user", value: properties.isInternalUser}) :
    userPropertiesArray.push({id: "A8SbkdXDgDaKwF_XPeIP8", name: "is_internal_user", value: null});
  properties.mainSpecialization !== undefined && properties.mainSpecialization !== null ?
    userPropertiesArray.push({id: "Q0TOe1qWy3Je_QK4xjSib", name: "main_specialization", value: properties.mainSpecialization}) :
    userPropertiesArray.push({id: "Q0TOe1qWy3Je_QK4xjSib", name: "main_specialization", value: null});
  properties.noaNotesAppUsed !== undefined && properties.noaNotesAppUsed !== null ?
    userPropertiesArray.push({id: "YWqru7VmDMc4DmrTlS55n", name: "noa_notes_app_used", value: properties.noaNotesAppUsed}) :
    userPropertiesArray.push({id: "YWqru7VmDMc4DmrTlS55n", name: "noa_notes_app_used", value: null});
  properties.profileAttractionRateUserProp !== undefined && properties.profileAttractionRateUserProp !== null ?
    userPropertiesArray.push({id: "U_c8fOHunqgyd2vGoY0Zs", name: "profile_attraction_rate", value: properties.profileAttractionRateUserProp}) :
    userPropertiesArray.push({id: "U_c8fOHunqgyd2vGoY0Zs", name: "profile_attraction_rate", value: null});
  properties.pmsDoctorId !== undefined && properties.pmsDoctorId !== null ?
    userPropertiesArray.push({id: "ul99JWaaObvTAMEhToNmN", name: "pms_doctor_id", value: properties.pmsDoctorId}) :
    userPropertiesArray.push({id: "ul99JWaaObvTAMEhToNmN", name: "pms_doctor_id", value: null});
  properties.hasActivatedNoaNotesTrial !== undefined && properties.hasActivatedNoaNotesTrial !== null ?
    userPropertiesArray.push({id: "nbHeDIiPEJVh-0SwRBFL9", name: "has_activated_noa_notes_trial", value: properties.hasActivatedNoaNotesTrial}) :
    userPropertiesArray.push({id: "nbHeDIiPEJVh-0SwRBFL9", name: "has_activated_noa_notes_trial", value: null});
  properties.noaNotesTrialExpirationDate !== undefined && properties.noaNotesTrialExpirationDate !== null ?
    userPropertiesArray.push({id: "s2fvp76c3cqFm3braX4iW", name: "noa_notes_trial_expiration_date", value: properties.noaNotesTrialExpirationDate}) :
    userPropertiesArray.push({id: "s2fvp76c3cqFm3braX4iW", name: "noa_notes_trial_expiration_date", value: null});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "YHsSWlG3j0MsyDXAww_tz", "83128a51cda71df30b90c448056db3a2f44cf729304b642856ebd22f4a35b144", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("user_properties_set", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("YHsSWlG3j0MsyDXAww_tz", "user_properties_set", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
  } else {
    // do nothing
  }
}

export interface UserPropertiesSetNoaMinusnotesProperties {
  userId_: string;
  mkplDoctorId?: string | null | undefined;
  mkplFacilityId?: string | null | undefined;
  mkplUserId?: string | null | undefined;
  pmsUserId?: string | null | undefined;
  saasDoctorId?: string | null | undefined;
  saasFacilityId?: string | null | undefined;
  saasUserId?: string | null | undefined;
  sourceUserId?: string | null | undefined;
  userType?: UserTypeValueType | null | undefined;
  countryCode?: string | null | undefined;
  isUserIntegrated?: boolean | null | undefined;
  hubspotUserId?: string | null | undefined;
  isInternalUser?: boolean | null | undefined;
  mainSpecialization?: string | null | undefined;
  noaNotesAppUsed?: NoaNotesAppUsedValueType | null | undefined;
  profileAttractionRateUserProp?: string | null | undefined;
  pmsDoctorId?: string | null | undefined;
  hasActivatedNoaNotesTrial?: boolean | null | undefined;
  noaNotesTrialExpirationDate?: string | null | undefined;
  hasNoaNotesChromePlugin: boolean;
  userStatus: string;
}
/**
 * user_properties_set: This event is designed to pass or update user property datavariant description: Used for Noa related sources
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.mkplDoctorId: Value from stage_marketplace.doctor.id, if available
 * @param properties.mkplFacilityId: Value from stage_marketplace.facility.id, if available
 * @param properties.mkplUserId: One of following value if meets criteria:
 * 1) Value from stage_marketplace.user_doctor_worker.doctor_id, when user_type = doctor; 
 * 2) Value from stage_marketplace.user.id, when user_type = patient;
 * 3) Value from stage_marketplace.user_doctor_worker.id where doctor_id is null, when user_type = DPworker
 * @param properties.pmsUserId: PMS generated user ID
 * @param properties.saasDoctorId: Value from saas.users.id where user_type = 1, if available
 * @param properties.saasFacilityId: Value from saas.users.id where user_type = 3, if available
 * @param properties.saasUserId: One of following value if meets criteria:
 * 1) Value from saas.users.id where user_type = 1, when user_type = doctor;
 * 2) Value from saas.users.id where user_type = 4, when user_type = secretary;
 * 3) Value from saas.users.id where user_type = 6, when user_type = secretaryInMedicalCenter;
 * 4) Value from saas.users.id where user_type = 3, when user_type = clinicAdmin.
 * @param properties.sourceUserId: User ID coming from the native destination, so if we are on saas it will be saas_user_id, if Feegow, it will be user_id from Feegow ecosystem, etc.
 * @param properties.userType: Self explanatory
 * @param properties.countryCode: User's country. 2 lowercase letters country code user belongs to. , should match regex: ^[a-z]{2}$
 * It refers to the local market, not to the country from which the user accesses the product.
 * For example, if a user accesses doctoralia.es from France, the country_code will be 'es' and not 'fr.'
 * @param properties.isUserIntegrated: For PMS only. Returns true whenever user is integrated to DP
 * @param properties.hubspotUserId: User ID coming from HubSpot
 * @param properties.isInternalUser: Returns true when user is an internal user (uses docplanner.com email domain). For our internal PMSes uses email domain of the PMS. 
 * It also returns true when is a testing user, used by docplanner employees to test our product.
 * @param properties.mainSpecialization: The main specialization of a doctor.
 * @param properties.noaNotesAppUsed: This is similar to the noa_notes_client system event property. We need it as a user property for segmentation purposes in Amplitude Feature Flags.
 * @param properties.profileAttractionRateUserProp: Captures the attraction ranking of a doctor's profile for patients based on the information filled in for their public profile. 
 * This property is set only when the freemium dashboard page is loaded. If a new user lands on a different page upon creating their account, they won't receive this information until they visit the freemium dashboard.
 * @param properties.pmsDoctorId: PMS Doctor ID. 
 * bi.dbt_refresher.mart_pms_user.pms_doctor_id
 * @param properties.hasActivatedNoaNotesTrial: Indicates if the user has activated Noa Trial at some point. This property should be combined with noa_notes_trial_expiration_date, to know if the user stills on trial or if it's expired.
 * @param properties.noaNotesTrialExpirationDate: Expiration date of the Noa Notes Trial. We should follow the following format: yyyy-mm-dd
 * @param properties.hasNoaNotesChromePlugin: True if the user has noa note chrome plugin, False if not.
 * @param properties.userStatus: Subscription status of a user:
 * trial active
 * trial expired
 * paid active
 * paid expired
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/YHsSWlG3j0MsyDXAww_tz.y4e5Q8oJdQnWCOtqar1RH}
 */
export function userPropertiesSetNoaNotes(properties: UserPropertiesSetNoaMinusnotesProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.mkplDoctorId !== undefined && properties.mkplDoctorId !== null ?
    userPropertiesArray.push({id: "ja9qDIylWzlEoZwbmrujy", name: "mkpl_doctor_id", value: properties.mkplDoctorId}) :
    userPropertiesArray.push({id: "ja9qDIylWzlEoZwbmrujy", name: "mkpl_doctor_id", value: null});
  properties.mkplFacilityId !== undefined && properties.mkplFacilityId !== null ?
    userPropertiesArray.push({id: "a-_AzEB5hLAR-0ffnK_SJ", name: "mkpl_facility_id", value: properties.mkplFacilityId}) :
    userPropertiesArray.push({id: "a-_AzEB5hLAR-0ffnK_SJ", name: "mkpl_facility_id", value: null});
  properties.mkplUserId !== undefined && properties.mkplUserId !== null ?
    userPropertiesArray.push({id: "StFAcqzfrMtXXpk7gP_lq", name: "mkpl_user_id", value: properties.mkplUserId}) :
    userPropertiesArray.push({id: "StFAcqzfrMtXXpk7gP_lq", name: "mkpl_user_id", value: null});
  properties.pmsUserId !== undefined && properties.pmsUserId !== null ?
    userPropertiesArray.push({id: "DMnAszKkTLJmpL2bKbS2n", name: "pms_user_id", value: properties.pmsUserId}) :
    userPropertiesArray.push({id: "DMnAszKkTLJmpL2bKbS2n", name: "pms_user_id", value: null});
  properties.saasDoctorId !== undefined && properties.saasDoctorId !== null ?
    userPropertiesArray.push({id: "qXM4zZ1lobTXhmkR33QHB", name: "saas_doctor_id", value: properties.saasDoctorId}) :
    userPropertiesArray.push({id: "qXM4zZ1lobTXhmkR33QHB", name: "saas_doctor_id", value: null});
  properties.saasFacilityId !== undefined && properties.saasFacilityId !== null ?
    userPropertiesArray.push({id: "5pL3ZetEtLLznCWef9kjO", name: "saas_facility_id", value: properties.saasFacilityId}) :
    userPropertiesArray.push({id: "5pL3ZetEtLLznCWef9kjO", name: "saas_facility_id", value: null});
  properties.saasUserId !== undefined && properties.saasUserId !== null ?
    userPropertiesArray.push({id: "0t74VLuL1w8-wqh0-c3_6", name: "saas_user_id", value: properties.saasUserId}) :
    userPropertiesArray.push({id: "0t74VLuL1w8-wqh0-c3_6", name: "saas_user_id", value: null});
  properties.sourceUserId !== undefined && properties.sourceUserId !== null ?
    userPropertiesArray.push({id: "u-SWkkrqvko09hXWpTaF-", name: "source_user_id", value: properties.sourceUserId}) :
    userPropertiesArray.push({id: "u-SWkkrqvko09hXWpTaF-", name: "source_user_id", value: null});
  properties.userType !== undefined && properties.userType !== null ?
    userPropertiesArray.push({id: "F4scsTw_aD__zLtt2ff-e", name: "user_type", value: properties.userType}) :
    userPropertiesArray.push({id: "F4scsTw_aD__zLtt2ff-e", name: "user_type", value: null});
  properties.countryCode !== undefined && properties.countryCode !== null ?
    userPropertiesArray.push({id: "yhSzBbnofK388pp58urqf", name: "country_code", value: properties.countryCode}) :
    userPropertiesArray.push({id: "yhSzBbnofK388pp58urqf", name: "country_code", value: null});
  properties.isUserIntegrated !== undefined && properties.isUserIntegrated !== null ?
    userPropertiesArray.push({id: "1qdS_D-dRMrVYCIlJ25sm", name: "is_user_integrated", value: properties.isUserIntegrated}) :
    userPropertiesArray.push({id: "1qdS_D-dRMrVYCIlJ25sm", name: "is_user_integrated", value: null});
  properties.hubspotUserId !== undefined && properties.hubspotUserId !== null ?
    userPropertiesArray.push({id: "5b4Hf14v3rTwN65RJ_2yy", name: "hubspot_user_id", value: properties.hubspotUserId}) :
    userPropertiesArray.push({id: "5b4Hf14v3rTwN65RJ_2yy", name: "hubspot_user_id", value: null});
  properties.isInternalUser !== undefined && properties.isInternalUser !== null ?
    userPropertiesArray.push({id: "A8SbkdXDgDaKwF_XPeIP8", name: "is_internal_user", value: properties.isInternalUser}) :
    userPropertiesArray.push({id: "A8SbkdXDgDaKwF_XPeIP8", name: "is_internal_user", value: null});
  properties.mainSpecialization !== undefined && properties.mainSpecialization !== null ?
    userPropertiesArray.push({id: "Q0TOe1qWy3Je_QK4xjSib", name: "main_specialization", value: properties.mainSpecialization}) :
    userPropertiesArray.push({id: "Q0TOe1qWy3Je_QK4xjSib", name: "main_specialization", value: null});
  properties.noaNotesAppUsed !== undefined && properties.noaNotesAppUsed !== null ?
    userPropertiesArray.push({id: "YWqru7VmDMc4DmrTlS55n", name: "noa_notes_app_used", value: properties.noaNotesAppUsed}) :
    userPropertiesArray.push({id: "YWqru7VmDMc4DmrTlS55n", name: "noa_notes_app_used", value: null});
  properties.profileAttractionRateUserProp !== undefined && properties.profileAttractionRateUserProp !== null ?
    userPropertiesArray.push({id: "U_c8fOHunqgyd2vGoY0Zs", name: "profile_attraction_rate", value: properties.profileAttractionRateUserProp}) :
    userPropertiesArray.push({id: "U_c8fOHunqgyd2vGoY0Zs", name: "profile_attraction_rate", value: null});
  properties.pmsDoctorId !== undefined && properties.pmsDoctorId !== null ?
    userPropertiesArray.push({id: "ul99JWaaObvTAMEhToNmN", name: "pms_doctor_id", value: properties.pmsDoctorId}) :
    userPropertiesArray.push({id: "ul99JWaaObvTAMEhToNmN", name: "pms_doctor_id", value: null});
  properties.hasActivatedNoaNotesTrial !== undefined && properties.hasActivatedNoaNotesTrial !== null ?
    userPropertiesArray.push({id: "nbHeDIiPEJVh-0SwRBFL9", name: "has_activated_noa_notes_trial", value: properties.hasActivatedNoaNotesTrial}) :
    userPropertiesArray.push({id: "nbHeDIiPEJVh-0SwRBFL9", name: "has_activated_noa_notes_trial", value: null});
  properties.noaNotesTrialExpirationDate !== undefined && properties.noaNotesTrialExpirationDate !== null ?
    userPropertiesArray.push({id: "s2fvp76c3cqFm3braX4iW", name: "noa_notes_trial_expiration_date", value: properties.noaNotesTrialExpirationDate}) :
    userPropertiesArray.push({id: "s2fvp76c3cqFm3braX4iW", name: "noa_notes_trial_expiration_date", value: null});
  userPropertiesArray.push({id: "8qhVMmwn9EIdtQrKqaTZ1", name: "has_noa_notes_chrome_plugin", value: properties.hasNoaNotesChromePlugin});
  userPropertiesArray.push({id: "AjtpoK6c8yOpy0pHmGENk", name: "user_status", value: properties.userStatus});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "YHsSWlG3j0MsyDXAww_tz.y4e5Q8oJdQnWCOtqar1RH", "4fbb41f63267b5e4d2c41b09a643606486cfa50dba44c43a41a7486bd1ef2d60", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("user_properties_set", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("YHsSWlG3j0MsyDXAww_tz.y4e5Q8oJdQnWCOtqar1RH", "user_properties_set", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
  } else {
    // do nothing
  }
}

export interface UserPropertiesSetSaasProperties {
  userId_: string;
  mkplDoctorId?: string | null | undefined;
  mkplFacilityId?: string | null | undefined;
  mkplUserId?: string | null | undefined;
  pmsUserId?: string | null | undefined;
  saasDoctorId?: string | null | undefined;
  saasFacilityId?: string | null | undefined;
  saasUserId?: string | null | undefined;
  sourceUserId?: string | null | undefined;
  userType?: UserTypeValueType | null | undefined;
  countryCode?: string | null | undefined;
  isUserIntegrated?: boolean | null | undefined;
  hubspotUserId?: string | null | undefined;
  isInternalUser?: boolean | null | undefined;
  mainSpecialization?: string | null | undefined;
  noaNotesAppUsed?: NoaNotesAppUsedValueType | null | undefined;
  profileAttractionRateUserProp?: string | null | undefined;
  pmsDoctorId?: string | null | undefined;
  hasActivatedNoaNotesTrial?: boolean | null | undefined;
  noaNotesTrialExpirationDate?: string | null | undefined;
}
/**
 * user_properties_set: This event is designed to pass or update user property datavariant description: User properties set for saas source
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.mkplDoctorId: Value from stage_marketplace.doctor.id, if available
 * @param properties.mkplFacilityId: Value from stage_marketplace.facility.id, if available
 * @param properties.mkplUserId: One of following value if meets criteria:
 * 1) Value from stage_marketplace.user_doctor_worker.doctor_id, when user_type = doctor; 
 * 2) Value from stage_marketplace.user.id, when user_type = patient;
 * 3) Value from stage_marketplace.user_doctor_worker.id where doctor_id is null, when user_type = DPworker
 * @param properties.pmsUserId: PMS generated user ID
 * @param properties.saasDoctorId: Value from saas.users.id where user_type = 1, if available
 * @param properties.saasFacilityId: Value from saas.users.id where user_type = 3, if available
 * @param properties.saasUserId: One of following value if meets criteria:
 * 1) Value from saas.users.id where user_type = 1, when user_type = doctor;
 * 2) Value from saas.users.id where user_type = 4, when user_type = secretary;
 * 3) Value from saas.users.id where user_type = 6, when user_type = secretaryInMedicalCenter;
 * 4) Value from saas.users.id where user_type = 3, when user_type = clinicAdmin.
 * @param properties.sourceUserId: User ID coming from the native destination, so if we are on saas it will be saas_user_id, if Feegow, it will be user_id from Feegow ecosystem, etc.
 * @param properties.userType: Self explanatory
 * @param properties.countryCode: User's country. 2 lowercase letters country code user belongs to. , should match regex: ^[a-z]{2}$
 * It refers to the local market, not to the country from which the user accesses the product.
 * For example, if a user accesses doctoralia.es from France, the country_code will be 'es' and not 'fr.'
 * @param properties.isUserIntegrated: For PMS only. Returns true whenever user is integrated to DP
 * @param properties.hubspotUserId: User ID coming from HubSpot
 * @param properties.isInternalUser: Returns true when user is an internal user (uses docplanner.com email domain). For our internal PMSes uses email domain of the PMS. 
 * It also returns true when is a testing user, used by docplanner employees to test our product.
 * @param properties.mainSpecialization: The main specialization of a doctor.
 * @param properties.noaNotesAppUsed: This is similar to the noa_notes_client system event property. We need it as a user property for segmentation purposes in Amplitude Feature Flags.
 * @param properties.profileAttractionRateUserProp: Captures the attraction ranking of a doctor's profile for patients based on the information filled in for their public profile. 
 * This property is set only when the freemium dashboard page is loaded. If a new user lands on a different page upon creating their account, they won't receive this information until they visit the freemium dashboard.
 * @param properties.pmsDoctorId: PMS Doctor ID. 
 * bi.dbt_refresher.mart_pms_user.pms_doctor_id
 * @param properties.hasActivatedNoaNotesTrial: Indicates if the user has activated Noa Trial at some point. This property should be combined with noa_notes_trial_expiration_date, to know if the user stills on trial or if it's expired.
 * @param properties.noaNotesTrialExpirationDate: Expiration date of the Noa Notes Trial. We should follow the following format: yyyy-mm-dd
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/YHsSWlG3j0MsyDXAww_tz.fNJ0etktFJVRmwdNHtixH}
 */
export function userPropertiesSetSaas(properties: UserPropertiesSetSaasProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.mkplDoctorId !== undefined && properties.mkplDoctorId !== null ?
    userPropertiesArray.push({id: "ja9qDIylWzlEoZwbmrujy", name: "mkpl_doctor_id", value: properties.mkplDoctorId}) :
    userPropertiesArray.push({id: "ja9qDIylWzlEoZwbmrujy", name: "mkpl_doctor_id", value: null});
  properties.mkplFacilityId !== undefined && properties.mkplFacilityId !== null ?
    userPropertiesArray.push({id: "a-_AzEB5hLAR-0ffnK_SJ", name: "mkpl_facility_id", value: properties.mkplFacilityId}) :
    userPropertiesArray.push({id: "a-_AzEB5hLAR-0ffnK_SJ", name: "mkpl_facility_id", value: null});
  properties.mkplUserId !== undefined && properties.mkplUserId !== null ?
    userPropertiesArray.push({id: "StFAcqzfrMtXXpk7gP_lq", name: "mkpl_user_id", value: properties.mkplUserId}) :
    userPropertiesArray.push({id: "StFAcqzfrMtXXpk7gP_lq", name: "mkpl_user_id", value: null});
  properties.pmsUserId !== undefined && properties.pmsUserId !== null ?
    userPropertiesArray.push({id: "DMnAszKkTLJmpL2bKbS2n", name: "pms_user_id", value: properties.pmsUserId}) :
    userPropertiesArray.push({id: "DMnAszKkTLJmpL2bKbS2n", name: "pms_user_id", value: null});
  properties.saasDoctorId !== undefined && properties.saasDoctorId !== null ?
    userPropertiesArray.push({id: "qXM4zZ1lobTXhmkR33QHB", name: "saas_doctor_id", value: properties.saasDoctorId}) :
    userPropertiesArray.push({id: "qXM4zZ1lobTXhmkR33QHB", name: "saas_doctor_id", value: null});
  properties.saasFacilityId !== undefined && properties.saasFacilityId !== null ?
    userPropertiesArray.push({id: "5pL3ZetEtLLznCWef9kjO", name: "saas_facility_id", value: properties.saasFacilityId}) :
    userPropertiesArray.push({id: "5pL3ZetEtLLznCWef9kjO", name: "saas_facility_id", value: null});
  properties.saasUserId !== undefined && properties.saasUserId !== null ?
    userPropertiesArray.push({id: "0t74VLuL1w8-wqh0-c3_6", name: "saas_user_id", value: properties.saasUserId}) :
    userPropertiesArray.push({id: "0t74VLuL1w8-wqh0-c3_6", name: "saas_user_id", value: null});
  properties.sourceUserId !== undefined && properties.sourceUserId !== null ?
    userPropertiesArray.push({id: "u-SWkkrqvko09hXWpTaF-", name: "source_user_id", value: properties.sourceUserId}) :
    userPropertiesArray.push({id: "u-SWkkrqvko09hXWpTaF-", name: "source_user_id", value: null});
  properties.userType !== undefined && properties.userType !== null ?
    userPropertiesArray.push({id: "F4scsTw_aD__zLtt2ff-e", name: "user_type", value: properties.userType}) :
    userPropertiesArray.push({id: "F4scsTw_aD__zLtt2ff-e", name: "user_type", value: null});
  properties.countryCode !== undefined && properties.countryCode !== null ?
    userPropertiesArray.push({id: "yhSzBbnofK388pp58urqf", name: "country_code", value: properties.countryCode}) :
    userPropertiesArray.push({id: "yhSzBbnofK388pp58urqf", name: "country_code", value: null});
  properties.isUserIntegrated !== undefined && properties.isUserIntegrated !== null ?
    userPropertiesArray.push({id: "1qdS_D-dRMrVYCIlJ25sm", name: "is_user_integrated", value: properties.isUserIntegrated}) :
    userPropertiesArray.push({id: "1qdS_D-dRMrVYCIlJ25sm", name: "is_user_integrated", value: null});
  properties.hubspotUserId !== undefined && properties.hubspotUserId !== null ?
    userPropertiesArray.push({id: "5b4Hf14v3rTwN65RJ_2yy", name: "hubspot_user_id", value: properties.hubspotUserId}) :
    userPropertiesArray.push({id: "5b4Hf14v3rTwN65RJ_2yy", name: "hubspot_user_id", value: null});
  properties.isInternalUser !== undefined && properties.isInternalUser !== null ?
    userPropertiesArray.push({id: "A8SbkdXDgDaKwF_XPeIP8", name: "is_internal_user", value: properties.isInternalUser}) :
    userPropertiesArray.push({id: "A8SbkdXDgDaKwF_XPeIP8", name: "is_internal_user", value: null});
  properties.mainSpecialization !== undefined && properties.mainSpecialization !== null ?
    userPropertiesArray.push({id: "Q0TOe1qWy3Je_QK4xjSib", name: "main_specialization", value: properties.mainSpecialization}) :
    userPropertiesArray.push({id: "Q0TOe1qWy3Je_QK4xjSib", name: "main_specialization", value: null});
  properties.noaNotesAppUsed !== undefined && properties.noaNotesAppUsed !== null ?
    userPropertiesArray.push({id: "YWqru7VmDMc4DmrTlS55n", name: "noa_notes_app_used", value: properties.noaNotesAppUsed}) :
    userPropertiesArray.push({id: "YWqru7VmDMc4DmrTlS55n", name: "noa_notes_app_used", value: null});
  properties.profileAttractionRateUserProp !== undefined && properties.profileAttractionRateUserProp !== null ?
    userPropertiesArray.push({id: "U_c8fOHunqgyd2vGoY0Zs", name: "profile_attraction_rate", value: properties.profileAttractionRateUserProp}) :
    userPropertiesArray.push({id: "U_c8fOHunqgyd2vGoY0Zs", name: "profile_attraction_rate", value: null});
  properties.pmsDoctorId !== undefined && properties.pmsDoctorId !== null ?
    userPropertiesArray.push({id: "ul99JWaaObvTAMEhToNmN", name: "pms_doctor_id", value: properties.pmsDoctorId}) :
    userPropertiesArray.push({id: "ul99JWaaObvTAMEhToNmN", name: "pms_doctor_id", value: null});
  properties.hasActivatedNoaNotesTrial !== undefined && properties.hasActivatedNoaNotesTrial !== null ?
    userPropertiesArray.push({id: "nbHeDIiPEJVh-0SwRBFL9", name: "has_activated_noa_notes_trial", value: properties.hasActivatedNoaNotesTrial}) :
    userPropertiesArray.push({id: "nbHeDIiPEJVh-0SwRBFL9", name: "has_activated_noa_notes_trial", value: null});
  properties.noaNotesTrialExpirationDate !== undefined && properties.noaNotesTrialExpirationDate !== null ?
    userPropertiesArray.push({id: "s2fvp76c3cqFm3braX4iW", name: "noa_notes_trial_expiration_date", value: properties.noaNotesTrialExpirationDate}) :
    userPropertiesArray.push({id: "s2fvp76c3cqFm3braX4iW", name: "noa_notes_trial_expiration_date", value: null});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "YHsSWlG3j0MsyDXAww_tz.fNJ0etktFJVRmwdNHtixH", "f350dff74e90a3e85e6eb8371a2959794730ee59aa6052a42b7a75c0a1220a8a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("user_properties_set", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("YHsSWlG3j0MsyDXAww_tz.fNJ0etktFJVRmwdNHtixH", "user_properties_set", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
  } else {
    // do nothing
  }
}

export interface NoaDoctorEnabledProperties {
  pageCategory?: PageCategoryValueType | null | undefined;
  pageSection?: PageSectionValueType | null | undefined;
  pageType: PageTypeValueType;
  pageUrl: string;
  noaIntegrationDoctorId: string;
}
/**
 * noa_doctor_enabled: This event is sent when a user turn on the toggle to Show Noa Notes in the Noa Hub
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/981c3812-e65f-4b09-8a50-a0aaddaedd12/trigger/NpF0M6X7a_hQiWee0Huo5
 * 
 * @param properties the properties associated with this event
 * @param properties.pageCategory: First level of hierarchy. Used to classify website and app content into broad sections. This primary classification helps in organizing and segmenting user interactions and behavior across different types of content.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageSection: Second layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageType: Type of page being displayed (Onboarding wizard)
 * Third layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category' and 'section'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageUrl: Complete URL from the page where the action is being triggered (including querystring). Frequently used window.location.href by developers
 * @param properties.noaIntegrationDoctorId: This is the id of the doctor from the database noa-notes-integration
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/981c3812-e65f-4b09-8a50-a0aaddaedd12}
 */
export function noaDoctorEnabled(properties: NoaDoctorEnabledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.pageCategory !== undefined && properties.pageCategory !== null ?
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: properties.pageCategory}) :
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: null});
  properties.pageSection !== undefined && properties.pageSection !== null ?
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: properties.pageSection}) :
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: null});
  eventPropertiesArray.push({id: "UMH-8vf-gOxjFNieQ86Ew", name: "page_type", value: properties.pageType});
  eventPropertiesArray.push({id: "CdQwMgzXad5mxij9Fp763", name: "page_url", value: properties.pageUrl});
  eventPropertiesArray.push({id: "04Hj7ntjJ4ot8znXUV-ux", name: "noa_integration_doctor_id", value: properties.noaIntegrationDoctorId});
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "981c3812-e65f-4b09-8a50-a0aaddaedd12", "007cbc1ece061efec2b68e8c463f03423668d50e464ea33f30e012029e5450a3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("noa_doctor_enabled", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("981c3812-e65f-4b09-8a50-a0aaddaedd12", "noa_doctor_enabled", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("noa_doctor_enabled", eventProperties, "981c3812-e65f-4b09-8a50-a0aaddaedd12", "007cbc1ece061efec2b68e8c463f03423668d50e464ea33f30e012029e5450a3");
    }
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.logEvent("noa_doctor_enabled", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NoaDoctorDisabledProperties {
  pageCategory?: PageCategoryValueType | null | undefined;
  pageSection?: PageSectionValueType | null | undefined;
  pageType: PageTypeValueType;
  pageUrl: string;
  noaIntegrationDoctorId: string;
}
/**
 * noa_doctor_disabled: This event is sent when a user turn off the toggle to Show Noa Notes in the Noa Hub
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/8d30cd94-8b4b-4495-b483-9a2ae7309966/trigger/zs64Ds0UpWgqH4-cDC03R
 * 
 * @param properties the properties associated with this event
 * @param properties.pageCategory: First level of hierarchy. Used to classify website and app content into broad sections. This primary classification helps in organizing and segmenting user interactions and behavior across different types of content.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageSection: Second layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageType: Type of page being displayed (Onboarding wizard)
 * Third layer of hierarchy. Provides a finer segmentation of website and app content within the broader 'category' and 'section'. This classification allows for deeper analysis by organizing user interactions and behaviors into more specific content areas.
 * Values assigned for the app try to mirror as much as possible the content structure on the web.
 * @param properties.pageUrl: Complete URL from the page where the action is being triggered (including querystring). Frequently used window.location.href by developers
 * @param properties.noaIntegrationDoctorId: This is the id of the doctor from the database noa-notes-integration
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/8d30cd94-8b4b-4495-b483-9a2ae7309966}
 */
export function noaDoctorDisabled(properties: NoaDoctorDisabledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.pageCategory !== undefined && properties.pageCategory !== null ?
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: properties.pageCategory}) :
    eventPropertiesArray.push({id: "A2-OaruUcIZpYK6EkLS2y", name: "page_category", value: null});
  properties.pageSection !== undefined && properties.pageSection !== null ?
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: properties.pageSection}) :
    eventPropertiesArray.push({id: "Q_yUYncYHgqGXGVoQY5WG", name: "page_section", value: null});
  eventPropertiesArray.push({id: "UMH-8vf-gOxjFNieQ86Ew", name: "page_type", value: properties.pageType});
  eventPropertiesArray.push({id: "CdQwMgzXad5mxij9Fp763", name: "page_url", value: properties.pageUrl});
  eventPropertiesArray.push({id: "04Hj7ntjJ4ot8znXUV-ux", name: "noa_integration_doctor_id", value: properties.noaIntegrationDoctorId});
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8d30cd94-8b4b-4495-b483-9a2ae7309966", "9a4b07e8f56733c7d0a29fbc32bce42fde369199d72b8b6dd8e6f67b6d82f782", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("noa_doctor_disabled", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8d30cd94-8b4b-4495-b483-9a2ae7309966", "noa_doctor_disabled", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("noa_doctor_disabled", eventProperties, "8d30cd94-8b4b-4495-b483-9a2ae7309966", "9a4b07e8f56733c7d0a29fbc32bce42fde369199d72b8b6dd8e6f67b6d82f782");
    }
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.logEvent("noa_doctor_disabled", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ExperimentAssignedProperties {
  testVariant: string;
  testId: string;
  payload?: Payload | null | undefined;
  pageUrl?: string | null | undefined;
}
/**
 * experiment_assigned: This is a technical event sent at the moment of allocating the user to the specifc experiment variant.
 * 
 * @param properties the properties associated with this event
 * @param properties.testVariant: This property is included in experiment events and indicates the variant to which the user has been assigned. Examples of values: 'variant a,' 'variant b,' 'control.'
 * @param properties.testId: This property is included in experiment events and indicates the name or ID of an experiment.
 * @param properties.payload: Object-type property included only in temporary events, allowing flexible addition of properties without consulting tracking. An example would be the following:
 * 'payload': {
 *     'num_visits_scheduled': <num_visits>, //integer
 *     'is_first_booking': true|false, //boolean
 *     'location': '<location>', //string i.e header
 *   }
 * @param properties.pageUrl: Complete URL from the page where the action is being triggered (including querystring). Frequently used window.location.href by developers
 * 
 * @see {@link https://www.avo.app/schemas/ZaA60qUig8uGf9ScQJhj/events/1C3kmjT8JZilyc-kSPhA7}
 */
export function experimentAssigned(properties: ExperimentAssignedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "o47gzy3npbeo8H1XY7HX4", name: "test_variant", value: properties.testVariant});
  eventPropertiesArray.push({id: "vUGA7vjIUFfKgGBoll2nn", name: "test_id", value: properties.testId});
  properties.payload !== undefined && properties.payload !== null ?
    eventPropertiesArray.push({id: "5I-_PDgCVsqtt6kjZAV_T", name: "payload", value: properties.payload}) :
    eventPropertiesArray.push({id: "5I-_PDgCVsqtt6kjZAV_T", name: "payload", value: null});
  properties.pageUrl !== undefined && properties.pageUrl !== null ?
    eventPropertiesArray.push({id: "CdQwMgzXad5mxij9Fp763", name: "page_url", value: properties.pageUrl}) :
    eventPropertiesArray.push({id: "CdQwMgzXad5mxij9Fp763", name: "page_url", value: null});
  eventPropertiesArray.push({id: "GwvnsrWb_Al4xQfDtFb7g", name: "event_source", value: sysEventSource});
  eventPropertiesArray.push({id: "tSZejMs8GbRvluy_LOjs2", name: "dp_source", value: sysDpSource});
  eventPropertiesArray.push({id: "3FC9WKDtNDjF13QfsgqNh", name: "screen_heigth", value: sysScreenHeigth});
  eventPropertiesArray.push({id: "9aNyQ1UJ0XKt_CKGuHFwC", name: "screen_width", value: sysScreenWidth});
  eventPropertiesArray.push({id: "L7TAen6DXHWhq3PQxEL8N", name: "pms_system", value: sysPmsSystem});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1C3kmjT8JZilyc-kSPhA7", "a8ef1000eef965c9484f0d526a0bdcddb460e41f9b8f925e2532528937ecc5bc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("experiment_assigned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1C3kmjT8JZilyc-kSPhA7", "experiment_assigned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_assigned", eventProperties, "1C3kmjT8JZilyc-kSPhA7", "a8ef1000eef965c9484f0d526a0bdcddb460e41f9b8f925e2532528937ecc5bc");
    }
    // destination DocplannerMainCustomersAmplitude
    DocplannerMainCustomersAmplitude.logEvent("experiment_assigned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  LogoutType,
  PageCategory,
  PageSource,
  UserType,
  EventSource,
  PageSection,
  PageType,
  LoginType,
  NoaNotesAppUsed,
  ProfileAttractionRate,
  DpSource,
  pageViewed,
  pageViewedFreemium,
  pageViewedPayments,
  pageViewedWithPageSource,
  userUnidentified,
  userLoggedOut,
  userLoggedIn,
  userPropertiesSet,
  userPropertiesSetNoaNotes,
  userPropertiesSetSaas,
  noaDoctorEnabled,
  noaDoctorDisabled,
  experimentAssigned,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["pageViewed","pageViewedFreemium","pageViewedPayments","pageViewedWithPageSource","userUnidentified","userLoggedOut","userLoggedIn","userPropertiesSet","userPropertiesSetNoaNotes","userPropertiesSetSaas","noaDoctorEnabled","noaDoctorDisabled","experimentAssigned"]
